import React from "react";
import GradingForm from "../GradingForm/GradingForm";

const ListingForm = ({ formData, setFormData }) => {
  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const fields = [
    { name: "price", label: "Price (USD)" },
    { name: "shippingCost", label: "Shipping Cost (USD)" },
    { name: "quantity", label: "Quantity", default: "1" },
    { name: "artist", label: "Artist" },
    { name: "title", label: "Title" },
    { name: "description", label: "Description", default: "" },
    { name: "genre", label: "Genre", default: [] },
    { name: "style", label: "Style", default: [] },
    { name: "material", label: "Material", default: "Vinyl" },
    { name: "type", label: "Type", default: [] },
    { name: "totalQty", label: "# LPS", default: "1" },
    { name: "label", label: "Record Label" },
    { name: "releaseYear", label: "Release Year" },
    { name: "catalogNumber", label: "Catalog Number" },
    { name: "upc", label: "UPC / EAN" },
    { name: "format", label: "Format" },
    { name: "color", label: "Color" },
    { name: "features", label: "Features" },
    { name: "edition", label: "Edition" },
    { name: "recordSize", label: "Record Size" },
    { name: "speed", label: "Speed" },
    { name: "caseType", label: "Case Type", default: "Cardboard Sleeve" },
    { name: "imageUrl", label: "Main Image URL" },
  ];

  const getValue = (field, defaultVal = "") => {
    const val = formData[field];
    if (Array.isArray(val)) {
      return val.join(", ");
    }
    return val !== undefined && val !== "" ? val : defaultVal;
  };

  return (
    <form className="space-y-6 mt-6 text-white">
      <h2 className="text-xl font-bold border-b border-zinc-700 pb-2">
        Grading
      </h2>

      <GradingForm
        mediaCondition={formData.conditionMedia}
        setMediaCondition={(val) =>
          setFormData((prev) => ({ ...prev, conditionMedia: val }))
        }
        sleeveCondition={formData.conditionSleeve}
        setSleeveCondition={(val) =>
          setFormData((prev) => ({ ...prev, conditionSleeve: val }))
        }
        inlayCondition={formData.conditionInlay}
        setInlayCondition={(val) =>
          setFormData((prev) => ({ ...prev, conditionInlay: val }))
        }
      />

      <h2 className="text-xl font-bold border-b border-zinc-700 pt-6 pb-2">
        Listing Details
      </h2>

      {fields.map(({ name, label, default: def }) => (
        <div key={name}>
          <label className="block text-sm font-medium text-zinc-300 mb-1">
            {label}
          </label>

          {name === "description" ? (
            <textarea
              ref={(el) => {
                if (el) {
                  el.style.height = 'auto';
                  el.style.height = el.scrollHeight + 'px';
                }
              }}
              className="w-full p-3 rounded-md bg-black text-white border border-zinc-700 placeholder-zinc-500 resize-none overflow-hidden"
              rows={2}
              value={getValue(name, def)}
              onChange={(e) => {
                handleChange(name)(e);
                e.target.style.height = 'auto';
                e.target.style.height = e.target.scrollHeight + 'px';
              }}
            />
          ) : (
            <>
              <input
                type="text"
                className="w-full p-3 rounded-md bg-black text-white border border-zinc-700 placeholder-zinc-500"
                value={getValue(name, def)}
                onChange={handleChange(name)}
              />
              {name === "imageUrl" && formData.imageUrl && (
                <img
                  src={formData.imageUrl}
                  alt="Preview"
                  className="mt-2 max-h-48 rounded border border-zinc-600 shadow"
                />
              )}
            </>
          )}
        </div>
      ))}
    </form>
  );
};

export default ListingForm;
